export const productShortName = "Meteorologia e Scienze dell'Atmosfera — Edizione Docenti";
export const productBrand = "Meteorologia e Scienze dell'Atmosfera";
export const productEdition = 'Edizione Docenti';
export const productImage = 'https://cdn.magicpatterns.com/uploads/m7VT6DNFgjCmeCncm6G3xQ/METEOROLOGIA_MOCKUP.png';
export const productImageAlt =
  "Meteorologia e Scienze dell'Atmosfera Edizione Docenti: collezione didattica in 6 volumi con 5 risorse bonus, circondata da strumenti meteorologici";

export const checkoutUrl = 'https://meteorologia-scienze-atmosfera-docenti.impultienda.ar/checkout';

export const price = '€19';
export const priceBefore = '€80';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = '€17';
export const bonusTotalValue = '€85';

export const assurances = ['Pagamento sicuro', 'Accesso immediato', 'Garanzia di 7 giorni'];

export const closingLines = [
  'Basta preparare ogni lezione da zero',
  'Basta spiegare fronti e pressione senza materiali chiari',
  'Basta cercare attività ed esperimenti sparsi su internet',
  "Basta verifiche improvvisate all'ultimo minuto",
  'Basta studenti distratti durante le lezioni di scienze',
];
